import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\ConsentController::show
* @see app/Http/Controllers/Auth/ConsentController.php:25
* @route '//bank.finesthub.de/consents'
*/
export const show = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '//bank.finesthub.de/consents',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\ConsentController::show
* @see app/Http/Controllers/Auth/ConsentController.php:25
* @route '//bank.finesthub.de/consents'
*/
show.url = (options?: RouteQueryOptions) => {
    return show.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\ConsentController::show
* @see app/Http/Controllers/Auth/ConsentController.php:25
* @route '//bank.finesthub.de/consents'
*/
show.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\ConsentController::show
* @see app/Http/Controllers/Auth/ConsentController.php:25
* @route '//bank.finesthub.de/consents'
*/
show.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\ConsentController::store
* @see app/Http/Controllers/Auth/ConsentController.php:42
* @route '//bank.finesthub.de/consents'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//bank.finesthub.de/consents',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\ConsentController::store
* @see app/Http/Controllers/Auth/ConsentController.php:42
* @route '//bank.finesthub.de/consents'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\ConsentController::store
* @see app/Http/Controllers/Auth/ConsentController.php:42
* @route '//bank.finesthub.de/consents'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

const consents = {
    show: Object.assign(show, show),
    store: Object.assign(store, store),
}

export default consents